import { render, staticRenderFns } from "./Cookieconsent.vue?vue&type=template&id=4508d85d&scoped=true"
import script from "./Cookieconsent.vue?vue&type=script&lang=js"
export * from "./Cookieconsent.vue?vue&type=script&lang=js"
import style0 from "./Cookieconsent.vue?vue&type=style&index=0&id=4508d85d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508d85d",
  null
  
)

export default component.exports